// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import UploadForm from "./uploadForm";
import GuidePage from "./GuidePage";
import DeleteAccount from "./DeleteAccount";
import AccountValidate from "./AccountValidate";
import PoliticaPrivacidad from "./PoliticaPrivacidad";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UploadForm />} />
        <Route path="/guia" element={<GuidePage />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/account-validate" element={<AccountValidate />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
      </Routes>
    </Router>
  );
}

export default App;